import { tns } from 'tiny-slider';

export function sponsorSlider() {
    let slider = document.getElementById('sponsor-slider');
    if (slider) {
        slider = tns({
            container: '#sponsor-slider',
            items: 1,
            gutter: 24,
            autoplay: true,
            center: false,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            navPosition: 'bottom',
            controlsPosition: 'bottom',
            controlsText: ['<img src="/assets/images/ui/prev.svg" alt="Vorige slide" width="" height="" loading="lazy">', '<img src="/assets/images/ui/next.svg" alt="Volgende slide" width="" height="" loading="lazy">'],
            nav: false,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                576: {
                    items: 2
                },
                768: {
                    items: 3
                },
                1024: {
                    items: 4
                },
                1366: {
                    items: 5,
                },
                1600: {
                    items: 6
                }
            }
        });
    }
    return 'sponsorSlider';
}

export function verslagenSlider() {
    let slider = document.getElementById('verslagen-slider');
    if (slider) {
        slider = tns({
            container: '#verslagen-slider',
            items: 1,
            gutter: 8,
            autoplay: true,
            center: false,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            navPosition: 'bottom',
            controlsPosition: 'bottom',
            controlsText: ['<img src="/assets/images/ui/prev.svg" alt="Vorige slide" width="" height="" loading="lazy">', '<img src="/assets/images/ui/next.svg" alt="Volgende slide" width="" height="" loading="lazy">'],
            nav: false,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                768: {
                    items: 2
                },
                1024: {
                    items: 3
                },
                1366: {
                    items: 4
                },
            }
        });
    }
    return 'verslagenSlider';
}